
export interface BidConfigMetaData {
    id: string;
    name: string;
    is_template: boolean;
    template_id?: string | null;
    project_id: string;
    is_active: boolean;
    version: number;

}

export interface Cell {
    value: string,
    // The convention for party: 0(false)=Developer, 1(true)=bidder
    party: boolean,
    type?: string | null,
    feedback?: any

}


export interface DataSheetConfig extends BidConfigMetaData {
    cells: any[];
}

export interface BidConfigWritable {
    name: string;
    is_template: boolean;
    cells: any[];
    history: any[];
}


/**
* THESE ARE PLACEHOLDERS UNTIL WE KNOW IF WE NEED BETTER...
 *
/**
 * middleware : app -> API
 * 1cells:
 * Array(3)
 * */
export function cellsEncoder(data: Cell[][]){
    return data.map(row => {
        return {cells: row.map(cell => {
            if(!cell.party){
                return cell.value;
            } else {
                return [cell.value, cell.party, cell.type]
            }
        })}
    })
}

/**
 * middleware : API -> app
 *
 *
 *   {cells: ["Division 02", "", ['', true]]}
 *
 * */
export function cellsDecoder(rows:any[]){
    return rows.map((row) => {
        return row.cells.map((cell:any) => {
            if(Array.isArray(cell)){
                if(cell.length === 1) {
                    return {value: cell[0], party: false}
                } else if(cell.length === 2){
                    return {value: cell[0], party: cell[1]}
                } else if(cell.length === 3){
                    return {value: cell[0], party: cell[1], type:cell[2]}
                } else if(cell.length === 4) {
                    return {value: cell[0], party: cell[1], type: cell[2], feedback: cell[3]}
                }
            }else{
                return {value: cell, party: false}
            }
        })
    })
}
